import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';

import actions from './actions';
import mutations from './mutations';
import getters from './getters';

import $_login from '../pages/login/_store';
import $_industry from '../pages/industry/_store';
import $_performance from '../pages/performance/_store';
import $_summary from '../pages/summary/_store';

Vue.use(Vuex);

const persistedStateKey = 'vuex-dashboard';

export const store = new Vuex.Store({ // eslint-disable-line
  state: {
    persistedStateKey,
    buildClientList: false,
    buildIndustryClientList: false,
    colors: {
      bar: {
        grey: '#b4bfc8',
        blue: '#3facc6',
        blueLight: '#c7e5ec',
        green: '#89ab53',
        greenLight: '#d2e5b4',
        pink: '#df5e6c',
        orange: '#ff8b4b',
      },
      text: {
        grey: '#7d8b96',
        blue: '#328ca1',
        green: '#6d9233',
        pink: '#c1535e',
        orange: '#db6b2e',
      },
      tableText: {
        grey: '#7d8b96',
        base: '#328ca1',
        prevYear1: '#6d9233',
        prevYear2: '#c1535e',
        prevYear3: '#db6b2e',
      },
      sets: {
        blueGrey: {
          bars: [
            '#3facc6',
            '#b4bfc8',
          ],
          text: [
            '#328ca1',
            '#7d8b96',
          ],
        },
        greenGrey: {
          bars: [
            '#89ab53',
            '#b4bfc8',
          ],
          text: [
            '#6d9233',
            '#7d8b96',
          ],
        },
        multi: {
          bars: [
            '#3facc6',
            '#89ab53',
            '#df5e6c',
            '#ff8b4b',
          ],
          text: [
            '#328ca1',
            '#6d9233',
            '#c1535e',
            '#db6b2e',
          ],
        },
      },
    },
    comparisonMode: 'industry',
    pre1Sep2019Mode: false,
    comparisonYears: '1',
    clientByIndustryLists: [],
    clientList: [],
    clientOrRareMode: 'client',
    currentColors: '',
    currentPage: '',
    defaultToDate: '',
    defaultFromDate: '',
    displayData: {
      pageTitle: '',
      showBurgerMenu: '',
      showLogoutIcon: '',
      showDownloadIcon: '',
      showNavigationLinks: '',
      showControlPanel: '',
      currentClient: '',
      totalApplications: {},
      rankPosition: 0,
      rankTotal: 0,
    },
    industrySelectStateDisabled: false,
    initialLoad: {
      summary: true,
      industry: true,
    },
    legendData: [],
    modalStates: {
      loadingModal: false,
      summaryLoadingState: 'stopped',
      industryLoadingState: 'stopped',
      companySelectModalState: false,
      datePickerModalState: false,
    },
    requestParams: {
      currentClient: '',
      industryAverage: 0,
      toDate: '',
      fromDate: '',
      dataFormat: '',
      currentParamsHash: '',
      summaryParamsExitHash: '',
      industryOverviewParamsExitHash: '',
    },
    responseCache: {
      summary: {},
      industry: {},
      performance: {},
    },
    tableSortColumn: 'base',
  },
  actions,
  mutations,
  getters,
  modules: {
    $_login,
    $_industry,
    $_performance,
    $_summary,
  },
  // plugins: [vuexLocalStorage.plugin],
  plugins: [createPersistedState({
    key: persistedStateKey,
  })],
});
